import { Button } from "@material-ui/core";
import { get } from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import CommaPrice from "src/features/Utils/CommaPrice";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import QuantityButton from "src/features/QuantityButton";
import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";

import NoImage from "src/assets/no-image.jpg";

// import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles((theme) => ({
  avatar: { width: 67, height: 67 },
}));

export default ({ item, action, inCart }) => {
  const classes = useStyles();
  const [quantity, setQuantity] = useState(get(inCart, "amount") || 1);
  const handleChange = (val) => {
    setQuantity(val);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={1}>
          <Avatar
            src={get(item, "cover_img") || NoImage}
            variant="rounded"
            className={classes.avatar}
          />
        </Grid>
        <Grid item xs={4}>
          <Box>{get(item, "presentation.search_name")}</Box>
          <Box>{`${item.multiplier} ${item.presentation.presentation_name.name} x ${item.presentation.quantity} ${item.presentation.presentation_unit.name} / ${item.container.name}`}</Box>
          <Box>{get(item, "barcode")}</Box>
        </Grid>
        <Grid item xs={3}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Typography color={get(item, "is_promo") ? "primary" : "initial"}>
              {CommaPrice(
                get(item, "is_promo")
                  ? get(item, "promo_price")
                  : get(item, "price")
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <QuantityButton
              minValue={1}
              value={quantity}
              onChange={handleChange}
            />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Button color="secondary" onClick={() => action(quantity)}>
              {!!inCart ? "UPDATE CART" : "ADD TO CART"}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Box mt={1} mb={1}>
        <Divider />
      </Box>
    </Box>
  );
};
